import {makeStyles} from "@mui/styles";
import {ReactElement} from "react";
import {Box, Typography} from "@mui/material";

const useStyles = makeStyles(theme => ({
    bordered: {
        borderColor: "lightGrey",
        borderRadius: 5,
        borderStyle: "solid",
        borderWidth: 1,
        height: "calc(100% - 39px)",
        marginTop: -10,
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1)
    },
    content: {
        display: "flex",
        flexDirection: "column",
        height: "100%"
    },
    label: {
        position: "relative",
        color: "rgba(0, 0, 0, 0.6)",
        background: theme.palette.background.paper,
        left: 10,
        paddingLeft: 4,
        paddingRight: 4,
        top: 0
    }
}));

interface IBorderedBox {
    children: ReactElement | ReactElement []
    label?: string
}
export default function BorderedBox({children, label}: IBorderedBox) {
    const classes = useStyles();

    return (
        <Box className={classes.content}>
            <Box>
                {label && <Typography className={classes.label} variant="caption">{label}</Typography>}
            </Box>
            <Box className={classes.bordered}>
                {children}
            </Box>
        </Box>
    );
}